export class EstGroupsListModel {
    ID: number;
    pet_no: number;
    description: string;
    type: string;
    date_created: string;
    remarks: string;
    created_by: string;
    total?: number;

    constructor(
        ID: number,
        pet_no: number,
        description: string,
        type: string,
        date_created: string,
        remarks: string,
        created_by: string,
        total?: number
    ) {
        this.ID = ID;
        this.pet_no = pet_no;
        this.description = description;
        this.type = type;
        this.date_created = date_created;
        this.remarks = remarks;
        this.created_by = created_by;
        this.total = total;
    }
}
